/**
 * Galaxies configuration
 *
 * This file is auto-generated by the balance importer.
 * Do not edit manually - changes will be overwritten.
 *
 * Generated at: 2025-09-25T12:43:18.987Z
 */

import { ConfigType } from './ConfigType';

export interface GalaxyConfig {
  galaxy_id: string;
  name: string;
  base_hp_mult: number;
  base_armor_step: number;
  base_resist_profile: Record<string, any>;
  notes: string;
  configType: ConfigType.GALAXIES;
}

export const galaxiesData: Record<string, GalaxyConfig> = {
  G1: {
    galaxy_id: 'G1',
    name: 'Neon Cluster',
    base_hp_mult: 1,
    base_armor_step: 0,
    base_resist_profile: ['{laser:0', 'bomb:0}'],
    notes: 'стартовая галактика',
    configType: ConfigType.GALAXIES,
  },
};

/**
 * Get GalaxyConfig by galaxy_id
 */
export function getGalaxies(id: string): GalaxyConfig | undefined {
  return galaxiesData[id];
}

/**
 * Get all GalaxyConfig entries
 */
export function getAllGalaxies(): GalaxyConfig[] {
  return Object.values(galaxiesData);
}

/**
 * Check if GalaxyConfig exists
 */
export function hasGalaxies(id: string): boolean {
  return id in galaxiesData;
}
